import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Autumn/AdditionAndSubtraction/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'AdditionAndSubtraction',
  field: 'Number',
  weeks: [4, 5],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/AdditionAndSubtraction/1MentalStrategies" */ './1MentalStrategies'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/AdditionAndSubtraction/2AddWholeNumbersWithMoreThanFourDigits" */ './2AddWholeNumbersWithMoreThanFourDigits'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/AdditionAndSubtraction/3SubtractWholeNumbersWithMoreThanFourDigits" */ './3SubtractWholeNumbersWithMoreThanFourDigits'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/AdditionAndSubtraction/4RoundToCheckAnswers" */ './4RoundToCheckAnswers'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/AdditionAndSubtraction/5InverseOperationsAdditionAndSubtraction" */ './5InverseOperationsAdditionAndSubtraction'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/AdditionAndSubtraction/6MultiStepAdditionAndSubtractionProblems" */ './6MultiStepAdditionAndSubtractionProblems'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/AdditionAndSubtraction/7CompareCalculations" */ './7CompareCalculations'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/AdditionAndSubtraction/8FindMissingNumbers" */ './8FindMissingNumbers'
        )
    })
  ]
});
export default Block;
